import { render, staticRenderFns } from "./ChildsFightsEffectivenessChart.vue?vue&type=template&id=6b9800ed"
import script from "./ChildsFightsEffectivenessChart.vue?vue&type=script&lang=js"
export * from "./ChildsFightsEffectivenessChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports